import { CardTemplateProps } from 'medere-ui-framework'
import { useMemo } from 'react'
import { UsersListItemDTO } from '../../../dto/users/UsersDTO'
import LocationActionMenu, { LocationActionItem } from '../../Location/tabs/components/LocationActionMenu'

export interface UsersCardActionsProps {
  onView: (item: UsersListItemDTO) => void
  onEdit: (item: UsersListItemDTO) => void
  onDelete: (item: UsersListItemDTO) => void
}

type UsersListCardProps = CardTemplateProps & UsersCardActionsProps & {
  entity: UsersListItemDTO
}

function normalizeCardValue(value: string | null | undefined, emptyText = 'Sin datos') {
  const normalizedValue = String(value ?? '').trim()
  return normalizedValue !== '' ? normalizedValue : emptyText
}

export default function UsersListCard({
  entity,
  onView,
  onEdit,
  onDelete,
}: Readonly<UsersListCardProps>) {
  const cardMenuItems: LocationActionItem[] = useMemo(() => [
    {
      label: 'Ver detalle',
      icon: 'pi pi-eye',
      action: () => onView(entity),
    },
    {
      label: 'Editar',
      icon: 'pi pi-file-edit',
      action: () => onEdit(entity),
    },
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      action: () => onDelete(entity),
    },
  ], [entity, onDelete, onEdit, onView])

  const fullname = `${normalizeCardValue(entity.firstname, '')} ${normalizeCardValue(entity.lastname, '')}`.trim() || 'Sin nombre'
  const username = normalizeCardValue(entity.username)
  const document = normalizeCardValue(entity.document)
  const profile = normalizeCardValue(entity.profile)
  const status = entity.blocked ? 'Bloqueado' : 'Activo'

  return (
    <article className='users-entities-mobile-card'>
      <div className='users-entities-mobile-card-header'>
        <h3 className='users-entities-mobile-card-title'>{fullname}</h3>
        <LocationActionMenu
          items={cardMenuItems}
          buttonClassName='p-button-text users-entities-mobile-card-menu-btn'
          ariaLabel='Opciones del usuario'
          panelClassName='users-entities-action-menu-panel'
          contentClassName='w-64'
        />
      </div>

      <div className='users-entities-mobile-card-body'>
        <div className='users-entities-mobile-card-row'>
          <span className='users-entities-mobile-card-key'>Usuario</span>
          <span className='users-entities-mobile-card-value'>{username}</span>
        </div>
        <div className='users-entities-mobile-card-row'>
          <span className='users-entities-mobile-card-key'>N° de Documento</span>
          <span className='users-entities-mobile-card-value'>{document}</span>
        </div>
        <div className='users-entities-mobile-card-row'>
          <span className='users-entities-mobile-card-key'>Perfil</span>
          <span className='users-entities-mobile-card-value'>{profile}</span>
        </div>
        <div className='users-entities-mobile-card-row'>
          <span className='users-entities-mobile-card-key'>Estado</span>
          <span className='users-entities-mobile-card-value'>{status}</span>
        </div>
      </div>
    </article>
  )
}
